import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LineStateActionService } from '../statemanagement/line-state-action.service';

@Component({
    selector: 'app-form-fail',
    templateUrl: './form-fail.component.html',
    styleUrls: ['./form-fail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFailComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private lineStateAction: LineStateActionService,
  ) { }

  body = ""
  code = "";
  comcode = "insure";
  btnOk = signal<string>("คลิก");
  isShowButton = false;

  error_template = {
    "E501": `ขออภัยท่านเคยลงทะเบียนเครื่องนี้กับ หมายเลขบัตรประชาชนอื่นไว้แล้ว กรุณาติดต่อเจ้าหน้าที่เพื่อตรวจสอบและแก้ไขข้อมูล โทร <a href="tel:#telephone_value#">#telephone_text#</a>`
  }

  telephone_template = {
    'insure': {
      "text": "02 633 6060",
      "value": "026336060"
    },
    'mazda': {
      "text": "02 633 6066",
      "value": "026336066"
    },
    'ford': {
      "text": "02 633 6080",
      "value": "026336080"
    },
    'nissan': {
      "text": "02 633 6040",
      "value": "026336040"
    }
  }

  ngOnInit() {
    const channel = this.lineStateAction.channelStateInfo;
    this.route.queryParams
      .subscribe(async (params) => {
        this.code = params.code;
        this.comcode = channel.comCode;
        if (params.code == "E501") {
          this.btnOk.set("โทร");
          this.isShowButton = true;
          const telephone_text = this.telephone_template[this.comcode].text;
          const telephone_value = this.telephone_template[this.comcode].value;
          this.body = this.error_template['E501'].replace('#telephone_text#', telephone_text).replace('#telephone_value#', telephone_value)
        }
      });
  }

  onOk() {
    if (this.code == "E501") {
      window.location.href = `tel:${this.telephone_template[this.comcode].value}`
    }
  }

}
